import React, {Component} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import * as userService from '../../../services/userService';
import InputNotification from '../../common/InputNotification';
import Header from '../Header';
// import ReactGA from 'react-ga';
import ReactCodeInput from 'react-verification-code-input';

class EmailVerification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data:
                {
                    sixDigitCode: ''
                },
            spinnerActive: false,

            codeInvalid: false,
            codeValid: false,
            errors: {},
            codeResent: false,
            codeResendFailed: false,
            email: ''
        };
    }

    doSubmit = async (type = null) => {
        try {
            if (!type) {
                await this.setState({spinnerActive: true});
                const resp = await userService.activation_code(this.state.data.sixDigitCode);
                await this.setState({spinnerActive: false});

                if (resp.data.is_active === 0) {
                    this.setState({
                        codeValid: false,
                        codeInvalid: true
                    })
                } else {
                    await this.setState({
                        codeInvalid: false,
                        codeValid: true
                    })

                    toastr.success("Account successfully validated.");
                    this.props.updateUser({active: 1});
                    this.props.history.push('insert-name')
                }

            }
        } catch (ex) {
            this.setState({spinnerActive: false});
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                //console.log(ex.response.data);
                errors = ex.response.data.errors;
                this.setState({errors});
            }
        }
    };

    resendConfirmationCode = async () => {
        const userId = localStorage.getItem("user_id");
        // console.log(userId);
        try {
            http.get('api/resend-activation/' + userId, {headers: {authorization: getJwt()}});
            this.setState({codeResent: true})
        } catch (ex) {
            this.setState({codeResendFailed: true})
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors = ex.response.data.errors;
                this.setState({errors});
            }
            if (ex.response && ex.response.status === 401) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors.email = ex.response.data.message;
                this.setState({errors});
            }
        }
    }

    componentDidMount() {
        //  ReactGA.pageview(window.location.pathname + window.location.search);
        // console.log('Evo ga email iz local storage-a: ', localStorage.getItem('email'));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Pageview',
            pagePath: '/email-verification',
            pageTitle: 'Email Verification',
        });
        const email = localStorage.getItem('email') ? localStorage.getItem('email') : '';
        if (email) {
            this.setState({email})
        }
    }

    componentDidUpdate() {
    }

    render() {

        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Check your email!</h1>
                        <p>We’ve sent a 6-digit confirmation code to <br/>
                            <strong>{this.state.email ? this.state.email : ''}.</strong><br/>
                            It will expire shortly, so enter it soon.</p>
                        <ReactCodeInput
                            // fieldHeight='80px'
                            // fieldWidth='60px'
                            onChange={async (value) => await this.setState({
                                data: {sixDigitCode: value},
                                codeInvalid: false,
                            })}
                            onComplete={async (value) => {
                                await this.setState({
                                    data: {sixDigitCode: value}
                                })
                                await this.doSubmit()
                            }}
                            autoFocus={true}
                            className={this.state.codeInvalid ? 'verification-code-invalid' : 'verification-code'}
                        />
                        {
                            this.state.spinnerActive ?
                                <InputNotification type={'loading'} text={'Validating your code...'}/> :
                                this.state.codeInvalid ?
                                    <InputNotification type={'danger'}
                                                       text={'That code wasn’t valid. Give it another try!'}/> :
                                    this.state.codeValid ?
                                        <InputNotification type={'success'}
                                                           text={'You successfully confirmed your email'}/> : null
                        }
                        <div>
                            <p>Keep this window open while checking your email.<br/>
                                Remember to check your spam folder! <br/><br/>
                            </p>
                            <p>Still can't find it? {
                                this.state.codeResendFailed ?
                                    <span className={'red-text'}>Confirmation code was resent</span> :
                                    this.state.codeResent ?
                                        <span className={'green-text'}>Confirmation code was resent</span> :
                                        <a onClick={() => this.resendConfirmationCode()}>Resend confirmation code</a>}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default EmailVerification;